import _ from 'lodash';
import {ENDPOINT_TRACKER} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getTrackers = () => {
  return fetch(ENDPOINT_TRACKER, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getTrackerById = (trackerId) => {
  return fetch(ENDPOINT_TRACKER + trackerId, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getTrackerTargetById = (trackerId, targetId) => {
  const endpointToUse = `${ENDPOINT_TRACKER}target/${targetId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getTrackerTargetItems = (targetId, queryParams) => {
  const queryString = _.join(
    _.map(queryParams, (value, key) => `${key}=${value}`),
    '&'
  );
  const endpointToUse = `${ENDPOINT_TRACKER}target/${targetId}/items${
    queryString ? '?' + queryString : ''
  }`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

// unpaginated version of the above getTrackerTargetItems for excel export
const getTrackerTargetAllItems = (targetId, queryParams) => {
  const queryString = _.join(
    _.map(queryParams, (value, key) => `${key}=${value}`),
    '&'
  );
  const endpointToUse = `${ENDPOINT_TRACKER}target/${targetId}/allItems${
    queryString ? '?' + queryString : ''
  }`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getTrackers,
  getTrackerById,
  getTrackerTargetById,
  getTrackerTargetItems,
  getTrackerTargetAllItems,
};
